import { render, staticRenderFns } from "./OptionsUser.vue?vue&type=template&id=49fea4a3&"
import script from "./OptionsUser.vue?vue&type=script&lang=js&"
export * from "./OptionsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports